// Utilidades para manejo de sesiones en vivo

/**
 * Calcula el tiempo restante hasta una sesión en ms
 */
export const getTimeUntilSession = (startAt) => {
  const sessionTime = new Date(startAt).getTime();
  const now = Date.now();
  return sessionTime - now;
};

/**
 * Formatea el tiempo restante en formato legible
 */
export const formatTimeUntil = (ms) => {
  if (ms < 0) return 'Iniciada';
  
  const hours = Math.floor(ms / (1000 * 60 * 60));
  const minutes = Math.floor((ms % (1000 * 60 * 60)) / (1000 * 60));
  
  if (hours >= 24) {
    const days = Math.floor(hours / 24);
    return `en ${days}d ${hours % 24}h`;
  }
  
  if (hours > 0) {
    return `en ${hours}h ${minutes}min`;
  }
  
  return `en ${minutes}min`;
};

/**
 * Formatea una fecha de sesión en formato legible
 */
export const formatSessionDate = (startAt) => {
  const date = new Date(startAt);
  const now = new Date();
  const tomorrow = new Date(now);
  tomorrow.setDate(tomorrow.getDate() + 1);
  
  // Check if today
  if (date.toDateString() === now.toDateString()) {
    return `Hoy ${date.toLocaleTimeString('es', { hour: '2-digit', minute: '2-digit', hour12: true })}`;
  }
  
  // Check if tomorrow
  if (date.toDateString() === tomorrow.toDateString()) {
    return `Mañana ${date.toLocaleTimeString('es', { hour: '2-digit', minute: '2-digit', hour12: true })}`;
  }
  
  // This week
  const daysUntil = Math.floor((date - now) / (1000 * 60 * 60 * 24));
  if (daysUntil < 7) {
    return date.toLocaleDateString('es', {
      weekday: 'long',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });
  }
  
  // Far future
  return date.toLocaleDateString('es', {
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  });
};

/**
 * Determina el badge a mostrar según el status y tiempo
 */
export const getSessionBadge = (module) => {
  const now = Date.now();
  const sessionTime = new Date(module.startAt).getTime();
  const timeUntil = sessionTime - now;
  
  if (module.status === 'live') {
    return {
      text: 'EN VIVO',
      color: 'bg-red-500 text-white animate-pulse',
      icon: '🟢'
    };
  }
  
  if (module.status === 'replay') {
    return {
      text: 'REPLAY DISPONIBLE',
      color: 'bg-gray-600 text-white',
      icon: '🎬'
    };
  }
  
  // upcoming
  const hoursUntil = timeUntil / (1000 * 60 * 60);
  if (hoursUntil < 24) {
    return {
      text: 'PRÓXIMA SESIÓN',
      color: 'bg-yellow-500 text-black',
      icon: '🕓'
    };
  }
  
  return {
    text: 'PROGRAMADA',
    color: 'bg-gray-700 text-gray-300',
    icon: '📅'
  };
};

/**
 * Obtiene el botón apropiado según estado
 */
export const getSessionButton = (module, isActive, onLockedClick) => {
  if (!isActive) {
    return {
      text: 'Activa tu acceso para participar en vivo',
      subtext: 'Puedes ver el temario, pero no entrar',
      variant: 'locked',
      onClick: onLockedClick
    };
  }
  
  if (module.status === 'live') {
    return {
      text: 'Entrar a la clase',
      subtext: 'Sesión en curso',
      variant: 'live',
      onClick: () => window.open(module.meetingUrl || '#', '_blank')
    };
  }
  
  if (module.status === 'replay') {
    return {
      text: 'Ver grabación',
      subtext: 'Disponible solo para alumnos activos',
      variant: 'replay',
      onClick: () => window.open(module.replayUrl || '#', '_blank')
    };
  }
  
  // upcoming
  return {
    text: 'Agendar recordatorio',
    subtext: 'Recibirás alerta 15 min antes',
    variant: 'upcoming',
    onClick: () => {
      // Crear evento de calendario (iCal)
      const event = {
        title: module.title,
        start: new Date(module.startAt),
        duration: module.durationMin
      };
      alert('Funcionalidad de calendario próximamente');
    }
  };
};

/**
 * Encuentra la próxima sesión global del curriculum
 */
export const getNextGlobalSession = (curriculum) => {
  const now = Date.now();
  let nextSession = null;
  let minTime = Infinity;
  
  // Primero verificar si hay alguna sesión en vivo
  for (const pilar of curriculum) {
    for (const module of pilar.modules) {
      if (module.status === 'live') {
        return {
          ...module,
          pilarTitle: pilar.title,
          isLive: true
        };
      }
    }
  }
  
  // Si no hay sesión en vivo, buscar la próxima upcoming
  for (const pilar of curriculum) {
    for (const module of pilar.modules) {
      if (module.status === 'upcoming') {
        const sessionTime = new Date(module.startAt).getTime();
        const timeUntil = sessionTime - now;
        
        if (timeUntil > 0 && timeUntil < minTime) {
          minTime = timeUntil;
          nextSession = {
            ...module,
            pilarTitle: pilar.title,
            timeUntil
          };
        }
      }
    }
  }
  
  return nextSession;
};
